import { Configuration, LogLevel } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID ?? 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    // localStorage so the MSAL cache is shared across tabs - otherwise
    // Ctrl-click / new-tab triggers a fresh SSO round-trip every time.
    // Safe here: the app doesn't render user-controlled HTML, and Entra
    // access tokens expire after ~1h with silent refresh handling renewal.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
}

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
}

// Scopes for acquiring a token to call our backend API
export const apiTokenRequest = {
  scopes: [`api://${import.meta.env.VITE_CLIENT_ID}/access_as_user`],
}
